//@flow
import React from 'react';
import MsrpToggleButton from './MsrpToggleButton.react';
import ModalActions from '../../Actions/modal';
import Constants from '../../constants';

import type MembershipPlanModel from '../../Stores/Membership/membershipPlanModel';

type Props = {
  membershipDiscount:number,
  quoteId:?string,
  isMsrp:boolean,
  moreText?:boolean,
  membershipPlan:MembershipPlanModel,
  showRow?:boolean,
};

function _getDiscountClass(props:Props):string {
  return props.isMsrp ? 'discount-text crossed-out' : 'discount-text';
}

function _openModal() {
  ModalActions.openModal(Constants.MSRP_POP_MODAL);
}

function _getText(props:Props) {
  if (props.moreText) return props.membershipPlan.getCheckoutDescription();
  return props.membershipPlan.getShortDescription();
}

export default function MsrpToggleInner(props:Props) {
  const discount = props.membershipDiscount.toFixed(2);
  const row = props.showRow ? 'row' : '';
  return(
    <div className={`subscription-switch opt2 msrp-toggle inner ${row}`}>
      <div className="content-group">
        <div>
          <div className="row accent-1 bold">
            <span className="toggle-columns columns small-9">
              <div className="sub-switcher-item-name toggle-title">
                <MsrpToggleButton quoteId={props.quoteId} isMsrp={props.isMsrp}/>
                <span className="title">{props.membershipPlan.getTitle() || "Free membership"}</span>
              </div>
            </span>
            <span className={`columns small-3 ${_getDiscountClass(props)}`}>-${discount}</span>
          </div>
        </div>
        <div className="body sub-switcher-item-text">
          {_getText(props)}&nbsp;
          <span onClick={_openModal} className="learn-more link-small">Learn more</span>
        </div>
      </div>
    </div>
  );
}
